(function($, _app) {
    _app.utils = _app.utils || {}

    const replaceFnWith = function(obj, fn) {
        let ret = {}
        for (const [k,f] of Object.entries(obj)) {
            if (typeof f === 'function')
                ret[k] = fn
        }
        return ret
    }
    
    _app.utils.forDevices = function (devices) {
        const r = {}
        const foundDevices = 
            devices && $(devices.map(d => '.device-' + d).join(',')).length > 0
        const nullFn = () => {}
        const passThoughFn = (callback) => callback()
        
        r['exec'] = foundDevices ? passThoughFn : nullFn
        
        for (const [k,f] of Object.entries(app.utils)) {
            if (f !== app.utils.forDevices) {
                if (typeof f === 'object')
                    r[k] = foundDevices ? f : replaceFnWith(f, nullFn)
                else
                    r[k] = foundDevices ? f : nullFn
            }
        }
        return r;
    }
})(jQuery, app);
 